"use client";

import { useZendeskTracking } from "hooks/useZendeskTracking";
import React from "react";
import type { FooterItem } from "@shared/graphql.types";
import { footerMenuItem } from "./FooterMenuItem.css";

interface Props {
  item: FooterItem;
}

export const ZendeskFooterMenuItem: React.FC<Props> = ({ item }) => {
  const href = useZendeskTracking(item.href);

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className={footerMenuItem}
      data-testid="footer-menuitem"
    >
      {item.title}
    </a>
  );
};
